// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "b8a4b49c6ec34e59d2ca" + ".css";
};